// tslint:disable
export var EnrollmentState;
(function (EnrollmentState) {
    // Running
    EnrollmentState[EnrollmentState["Running"] = 0] = "Running";
    // Complete
    EnrollmentState[EnrollmentState["Complete"] = 1] = "Complete";
    // Error
    EnrollmentState[EnrollmentState["Error"] = 2] = "Error";
})(EnrollmentState || (EnrollmentState = {}));
EnrollmentState['RUNNING'] = 0;
EnrollmentState['COMPLETE'] = 1;
EnrollmentState['ERROR'] = 2;
//# sourceMappingURL=EnrollmentState.js.map